import {CommonReducer, ReducerFromState} from "../../@types/reducers";
import {MarketCapObject} from "../../@types/response";


export const getMarketCap = (state: ReducerFromState<CommonReducer>): MarketCapObject => state.common.marketCap;